import { Banco } from 'src/app/entity/Banco';

export interface AnexoRequest {
  nomeArquivo: string;
  conteudo: string;
  type: string;
}

export interface RestituicaoRequest {
  restituicao: {
    nroDae: string;
    valorGuia: number;
    tipoRestituicao: 'T' | 'P';
    valorRestituir: number;
    motivo: string;
    exposicaoMotivo: string;
  };
  requerente: {
    nome: string;
    documento: string;
    email: string;
    telefone: string;
  };
  beneficiario: {
    tipo: 'R' | 'P'; // R = Requerente, P = Procurador
    tipoDocumentoConta: 'CPF' | 'CNPJ';
    nome: string;
    documento: string;
    bancoId: number;
    agencia: string;
    dvAgencia?: string;
    conta: string;
    dvConta: string;
  };
  anexos: AnexoRequest[];
}

function parseDecimal(value: any): number {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  if (typeof value === 'number') {
    return value;
  }

  let texto = value.toString().replace(/\./g, '');

  // Mask "separator.2" garante 2 casas decimais; se a vírgula não sobreviveu
  // (ex.: valor setado programaticamente sem passar pela digitação do mask),
  // reinserimos o separador decimal antes dos 2 últimos dígitos.
  if (!texto.includes(',') && /^\d{3,}$/.test(texto)) {
    texto = `${texto.slice(0, -2)},${texto.slice(-2)}`;
  }

  const normalized = texto.replace(',', '.');

  const parsed = Number(normalized);
  return isNaN(parsed) ? 0 : parsed;
}

export function mapRestituicaoFormToRequest(raw: any, anexos: AnexoRequest[] = []): RestituicaoRequest {
  const valorGuia = parseDecimal(raw.valorGuia);
  const tipoRestituicao = raw.tipoRestituicao as 'T' | 'P';
  const tipoDocumentoConta = raw.tipoDocumentoConta as 'CPF' | 'CNPJ';
  const valorRestituir =
    tipoRestituicao === 'P'
      ? parseDecimal(raw.valorRestituir)
      : valorGuia;

  const banco = raw.banco as Banco | null;

  return {
    restituicao: {
      nroDae: raw.nroDae as string,
      valorGuia,
      tipoRestituicao,
      valorRestituir,
      motivo: raw.motivo as string,
      exposicaoMotivo: raw.exposicaoMotivo as string
    },
    requerente: {
      nome: raw.nomeRequerente as string,
      documento: raw.cpfRequerente as string,
      email: raw.emailContato as string,
      telefone: raw.telefoneContato as string
    },
    beneficiario: {
      tipo: raw.titularConta as 'R' | 'P',
      tipoDocumentoConta: tipoDocumentoConta,
      nome: raw.nomeTitularConta as string,
      documento: normalizarDocumento(raw.cpfCnpjTitularConta, tipoDocumentoConta),
      bancoId: banco ? banco.id : 0,
      agencia: raw.agencia as string,
      dvAgencia: raw.dvAgencia as string,
      conta: raw.contaCorrente as string,
      dvConta: raw.dvContaCorrente as string
    },
    anexos
  };
}

function normalizarDocumento(value: any, tipoDocumento: 'CPF' | 'CNPJ'): string {
  const documento = String(value || '');

  if (tipoDocumento === 'CPF') {
    return documento.replace(/\D/g, '');
  }

  return documento.replace(/[^0-9a-zA-Z]/g, '').toUpperCase();
}
